import { render, staticRenderFns } from "./UpdateNoticeView.vue?vue&type=template&id=43df1089"
import script from "./UpdateNoticeView.vue?vue&type=script&lang=js"
export * from "./UpdateNoticeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports